/**
 * Os painéis laterais da conversa e a chave de `uiSettings` de cada um.
 *
 * Existe pra não haver duas listas: quem HOSPEDA o switch (hoje a
 * ConversationSheet do quadro) precisa ler e semear exatamente o conjunto que o
 * switch escreve. Duas cópias divergindo aqui viram painel que acende sozinho.
 */
export const PANEL_UI_SETTING_KEYS = Object.freeze({
  contact: 'is_contact_sidebar_open',
  copilot: 'is_copilot_panel_open',
  vision: 'is_vision_panel_open',
});

export const PANEL_NAMES = Object.freeze(Object.keys(PANEL_UI_SETTING_KEYS));

/** Qual painel a preferência PERSISTIDA do perfil deixa aberto (ou null). */
export const panelFromUISettings = settings =>
  PANEL_NAMES.find(name => settings?.[PANEL_UI_SETTING_KEYS[name]]) || null;

/** As chaves de `uiSettings` com só `name` ligado — `null` fecha todas. */
export const uiSettingsForPanel = name =>
  PANEL_NAMES.reduce(
    (acc, item) => ({ ...acc, [PANEL_UI_SETTING_KEYS[item]]: item === name }),
    {}
  );

/**
 * Chave do `provide`/`inject` que troca a preferência persistida por um estado
 * LOCAL de quem hospeda o switch.
 */
export const SIDEPANEL_INJECTION_KEY = 'conversationSidepanel';
